import App from "./App.svelte";
import checkEventData from "./js/checkEventData.js";
import props from "./content/data.json";

let resizeData = {};
let app;
/* Add 20px padding to the document to account for the scrollbar which 
   might be present within the iframe depending on browser / mouse combinations */
let extraHeight = 20;

function sendResizeMessage() {
  let documentHeight = document.querySelector("body").offsetHeight;
  window.parent.postMessage(
    { height: documentHeight + extraHeight, requestData: resizeData },
    "*"
  );

  console.log("sendResizeMessage:", {
    height: documentHeight + extraHeight,
    resizeData,
  });

  return null;
}

function handleMessage(event) {
  console.log("handleMessage");
  let goodEvent = checkEventData(event);
  if (goodEvent) {
    let { data } = event;
    resizeData = { ...data };
    sendResizeMessage();
  }

  return null;
}

function init() {
  app = new App({
    target: document.querySelector("body"),
    props: { ...props },
    hydrate: true,
  });

  app.$on("update", () => {
    sendResizeMessage();
  });
}

window.addEventListener("message", handleMessage);
document.addEventListener("DOMContentLoaded", init);

/* Check for flexbox gap support. Add 'no-flexbox-gap' class to body if false */
/* https://github.com/Modernizr/Modernizr/blob/master/feature-detects/css/flexgap.js */
window.addEventListener("DOMContentLoaded", () => {
  /* create flex container with row-gap set */
  let flex = document.createElement("div");
  flex.style.display = "flex";
  flex.style.flexDirection = "column";
  flex.style.rowGap = "1px";

  /* create two, elements inside it */
  flex.appendChild(document.createElement("div"));
  flex.appendChild(document.createElement("div"));

  /* append to the DOM (needed to obtain scrollHeight) */
  document.body.appendChild(flex);
  let isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
  flex.parentNode.removeChild(flex);

  if (!isSupported) {
    document.body.classList.add("no-flexbox-gap");
  }
});

export default app;
